import {
    apiRequest,
    userInfoCreate, 
    userInfoUpdate
} from "../../../../../../services/adapters/master/refMesinAbsenUserInfoService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", userInfoCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", userInfoUpdate, {
            body: query
        }, true)
    }

}

export default CreateRepository